import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import Rooms from './components/Rooms';
import Tradition from './components/Tradition';
import Location from './components/Location';
import Excursions from './components/Excursions';
import Breakfast from './components/Breakfast';
import Contact from './components/Contact';
import CtaBanner from './components/CtaBanner';
import Navigation from '../../components/feature/Navigation';
import StickyBooking from '../../components/feature/StickyBooking';
import Footer from '../../components/feature/Footer';
// import WelcomePopup from '../../components/feature/WelcomePopup';

export default function Home() {
  const [showStickyBooking, setShowStickyBooking] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowStickyBooking(window.scrollY > 600);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* <WelcomePopup /> */}
      <Navigation />
      <StickyBooking show={showStickyBooking} />
      <Hero />
      <Benefits />
      <Rooms />
      <Breakfast />
      <Tradition />
      <Location />
      <Excursions />
      <CtaBanner />
      <Contact />
      <Footer />
    </div>
  );
}